import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions(undefined, 'europe-west1');
const fn = httpsCallable(functions, 'logActivity');

// Fire-and-forget — blockerar aldrig UI och kastar aldrig vidare
export function logActivity(type, block) {
  try {
    fn({ type, block: block || null }).catch(() => {});
  } catch (_) { /* ignorera */ }
}
